// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
export const getEntityItemStyles = ({ entityItem = {} }, { palette = {} }) => ({
  entityItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    '& .entity-label': {
      fontSize: '12px',
      color: palette.neutralSecondary,
    },
    '& .entity-content': {
      display: 'flex',
      alignSelf: 'stretch',
      justifyContent: 'space-between',
    },
    '& .entity-text': {
      fontSize: '14px',
      color: palette.neutralPrimary,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .entity-icon': {
      fontSize: '16px',
      marginLeft: '10px',
      color: palette.themeDarkAlt,
      display: 'inline-block',
      cursor: 'pointer',
    },
  },
});
